import { render, staticRenderFns } from "./OStep0.vue?vue&type=template&id=52db227c&scoped=true"
import script from "./OStep0.vue?vue&type=script&lang=js"
export * from "./OStep0.vue?vue&type=script&lang=js"
import style0 from "./OStep0.vue?vue&type=style&index=0&id=52db227c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db227c",
  null
  
)

export default component.exports